<div>
    <div class="p-4 shadow-lg mb-3 rounded">
        <div class="row justify-content-center my-3">
            <div class="col-12 mb-2">
                <a class="btn btn-info text-uppercase font-weight-bold float-right" routerLink="/solicitudes">
                    <i class="fa fa-list" aria-hidden="true" ></i> Lista
                </a>
                <h4 class="text-center text-secondary text-uppercase font-weight-bold">Solicitud de rechazo</h4>
            </div>
            <form #segForm="ngForm" class="px-1 w-100">
                <div class="row">
                    <div class="col">
                        <label> Cliente </label>
                        <input 
                        type="text" 
                        class="form-control form-control-sm text-center"
                        [(ngModel)]="capacidad.petition.userName"
                        name="cliente"
                        [disabled]="viewRechazo"
                        >
                    </div>
                    <div class="col">
                        <label> No. identificasion </label>
                        <input type="text"
                        class="form-control form-control-sm text-center"
                        name="nro_identificacion"
                        [disabled]="viewRechazo"
                        >
                    </div>
                    <div class="col">
                        <label> No. solicitud </label>
                        <input 
                        type="Number"
                        class="form-control form-control-sm text-center"
                        [(ngModel)]="capacidad.id"
                        name="nro_solicitud"
                        [disabled]="viewRechazo"
                        >
                    </div>
                    <div class="col">
                        <label> Estado </label>
                        <ng-select
                        class="custom"
                        [(ngModel)]="capacidad.petition.processStatus"
                        name="Estado"
                        [disabled]="viewRechazo"
                        ></ng-select>
                    </div>
                </div>
                <div class="row">
                    <div class="col mt-3">
                        <label> Motivo </label>
                        <textarea class="form-control" cols="30" rows="5"></textarea>
                        <div class="check">
                            <label class="form-check-label pl-4 py-2" for="defaultCheck">
                                <input
                                class="form-check-input"
                                type="checkbox"
                                value=""
                                id="defaultCheck"
                                (click)="showFormulario()"
                                >
                                Ver Formulario
                            </label>
                        </div>
                    </div>
                </div>
                <div class="mt-3 container-buttons d-flex justify-content-end">
                    <div class="buttons">
                        <a class="btn btn-primary text-light ml-2 my-2" type="submit">Carga de Nueva Solicitud</a>
                        <a class="btn btn-primary text-light ml-2 my-2" type="button">Cierre Definido</a>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>